import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { ProductionListConf } from '../production-list-conf'
import { ProductionListConfDetailComponent } from '../production-list-conf-detail/production-list-conf-detail.component'

@Component({
  selector: 'app-production-list-conf-detail-side',
  templateUrl: './production-list-conf-detail-side.component.html',
  styleUrls: ['./production-list-conf-detail-side.component.scss'],
  imports: [ProductionListConfDetailComponent],
})
export class ProductionListConfDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public conf: ProductionListConf
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.conf = route.snapshot.data['conf']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
